import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34caf50a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-administrator-players-profile-diagnostics-list" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "box__headline" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Dijagnostika ", -1))
const _hoisted_5 = {
  key: 0,
  class: "box__list"
}
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "type" }
const _hoisted_9 = { class: "action" }
const _hoisted_10 = {
  key: 1,
  class: "box__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdministratorPlayersProfileDiagnosticsListFormCreateIndexVue = _resolveComponent("AdministratorPlayersProfileDiagnosticsListFormCreateIndexVue")!
  const _component_AdministratorPlayersProfileDiagnosticsListFormUpdateIndexVue = _resolveComponent("AdministratorPlayersProfileDiagnosticsListFormUpdateIndexVue")!
  const _component_AdministratorPlayersProfileDiagnosticsListFormRemoveIndexVue = _resolveComponent("AdministratorPlayersProfileDiagnosticsListFormRemoveIndexVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_AdministratorPlayersProfileDiagnosticsListFormCreateIndexVue, {
          diagnosticCategories: _ctx.diagnosticCategories,
          onGetDiagnostics: _ctx.getDiagnostics
        }, null, 8, ["diagnosticCategories", "onGetDiagnostics"])
      ]),
      (_ctx.diagnostics.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diagnostics, (diagnostic) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: diagnostic.id
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(diagnostic.user.content.name) + " " + _toDisplayString(diagnostic.user.content.surname), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.moment(diagnostic.content.date).format('DD.MM.YYYY.')) + " - " + _toDisplayString(diagnostic.diagnostic_category.content.name), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_AdministratorPlayersProfileDiagnosticsListFormUpdateIndexVue, {
                    diagnostic: diagnostic,
                    onGetDiagnostics: _ctx.getDiagnostics
                  }, null, 8, ["diagnostic", "onGetDiagnostics"]),
                  _createVNode(_component_AdministratorPlayersProfileDiagnosticsListFormRemoveIndexVue, {
                    diagnostic: diagnostic,
                    onGetDiagnostics: _ctx.getDiagnostics
                  }, null, 8, ["diagnostic", "onGetDiagnostics"])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, " Nema podataka... "))
    ])
  ]))
}